import React from "react";

// Real-Check logo mark — teal glowing cross.
export function LogoMark({ size = 36, className = "" }) {
    return (
        <img
            src="/logo-icon.png"
            alt="Real-Check compass mark"
            width={size}
            height={size}
            className={className}
            style={{ objectFit: "contain" }}
        />
    );
}

export function LogoWord({ className = "" }) {
    return (
        <div className={`flex items-center gap-2.5 ${className}`}>
            <LogoMark size={46} />
            <div className="font-display font-bold text-xl tracking-tight text-accent">
                Real<span className="text-primary/90">-Check</span>
                <span className="text-muted-foreground text-xs font-medium ml-1">.org</span>
            </div>
        </div>
    );
}
